import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { PaymentRegisterComponent } from './payment-register/payment-register.component';
import { StripeResolver } from './stripe.resolver';

const routes: Routes = [
  {
    path: 'payment',
    title: 'parentPayment',
    resolve: {
      stripe: StripeResolver
    },
    component: PaymentRegisterComponent
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, {})],
  exports: [RouterModule]
})
export class PaymentRoutingModule {}
